export const imagePlaceholder = "https://via.placeholder.com/100?text=PX+Stores";